import { type LabelHTMLAttributes } from 'react';
import clsx from 'clsx';
import { type FCC } from 'types';
import styles from './Label.module.scss';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  error?: string;
}

const Label: FCC<LabelProps> = ({ children, error, className, ...restProps }) => (
  <label {...restProps} className={clsx(styles.label, className, { [styles.error]: !!error })}>
    {children}
  </label>
);

export default Label;
